// images
import contactImage from "../assets/images/background/contact-us.jpg";
import ItcChennaiIndia from "../assets/images/itc-chennai-india.png";
import contact from "../assets/images/contact.png";

// brand
import pharmaSos from "../assets/images/brand/pharma-sos-logo.png";
import pharmaSosWhite from "../assets/images/brand/pharma-sos-logo-white.png";

// sliders
import indiaConference from "../assets/images/slides/pharma-sos-india-conference.jpg";

// about us images
import aboutUs from "../assets/images/about-us/about.jpg";

// shape
import brushStroke from "../assets/images/shape/brush-stroke.svg";
import brushStrokeGreen from "../assets/images/shape/brush-stroke-green.svg";
import brushStrokeWhite from "../assets/images/shape/brush-stroke-white.svg";
import brushStrokeGreenFlip from "../assets/images/shape/brush-stroke-green-flip.svg";
// events details
// import chennaiEvents from "../assets/images/events/pharma-sos-indian-conference.jpg";
import chennaiEvents from "../assets/images/events/innovate-pharma.jpg";
import summerEventMorristown from "../assets/images/events/summer-camp-morritown-nj.jpg";
import eventVenetianCasinoLasvegas from "../assets/images/events/event-venetian-casino-las-vegas.jpg";
import annualConference2025 from "../assets/images/events/annual-conference-2025.jpeg";
import bowlingCareset from "../assets/images/events/bowling-careset.jpg";
import hyderabadEvent from "../assets/images/events/annual-conference-hyderabad.jpeg";
import hyderabadEventCleanBg from "../assets/images/events/annual-conference-hyderabad-without-text.png";
import fallEvent from "../assets/images/events/fall-event.png";
import annualConferenceTranformation from "../assets/images/events/annual-conference-transformation-innovation.jpg";
import winterSocialBoston from "../assets/images/events/winter-social-boston.jpg";

// team details
import taogu from "../assets/images/team/board-of-directors/tao-gu.jpg";
import KarthikChidambaram from "../assets/images/team/board-of-directors/karthik-chidambaram.jpg";
import ashishPatel from "../assets/images/team/board-of-directors/ashish-patel.jpg";
import daveBitner from "../assets/images/team/board-of-directors/dave-bitner.jpg";
import davidPurdie from "../assets/images/team/board-of-directors/david-purdie.jpg";
import janeChen from "../assets/images/team/board-of-directors/jane-chen.jpg";
import jasonCarlin from "../assets/images/team/board-of-directors/jason-carlin.jpg";
import jinTong from "../assets/images/team/board-of-directors/jin-tong.jpg";
import paulomiPatel from "../assets/images/team/board-of-directors/paulomi-patel.jpg";
import sakthiAnnamalai from "../assets/images/team/board-of-directors/sakthi-annamalai.jpg";
import shanYeh from "../assets/images/team/board-of-directors/shan-yeh.jpg";
import somySilvy from "../assets/images/team/board-of-directors/somy-silvy.jpg";
import mayankMisra from "../assets/images/team/board-of-directors/mayan-misra.jpg";

// breadcrumb
import aboutUsImage from "../assets/images/background/about-us.jpg";
import contactUsImage from "../assets/images/background/contact-us.jpg";
import agendaImage from "../assets/images/background/agenda.jpg";
import sponsorsImage from "../assets/images/background/sponsors.jpg";
import eventandRegistration from "../assets/images/background/registration.jpg";
import pastEvents from "../assets/images/background/past-events.jpg";
import joinWithUsImage from "../assets/images/background/join-with-us.jpg";
import subscribeNewsletter from "../assets/images/background/subscribe-newsletter-team.jpg";
import becomeVolunteers from "../assets/images/background/volunteers.jpg";
import contactBg from "../assets/images/background/contact.jpg";
import weloveToHearBg from "../assets/images/background/we-love-to-hear.jpg";
import abstractSubmission from "../assets/images/background/abstract-submission.jpg";
import innovatePhrama2024 from "../assets/images/background/innovate-pharma-2024.jpg";
import innovatePhrama2024Gallery from "../assets/images/background/innovate-pharma-2024-gallery.jpg";
import galleryImage from "../assets/images/background/gallery.jpg";

// volunteers
import jessYoung from "../assets/images/team/volunteers/jess-young.jpg";
import ashleyPeterson from "../assets/images/team/volunteers/ashley-peterson.jpg";
import deviPrasadSingh from "../assets/images/team/volunteers/devi-prasad-singh.jpg";
import blankImage from "../assets/images/team/volunteers/amy-benford.jpg";
import placeholderMenImage from "../assets/images/team/speakers/placeholder-image.jpg";
import wingchan from "../assets/images/team/board-of-directors/wing-chan.jpg";
import joeFalcone from "../assets/images/team/volunteers/joe-falcone.png";

// speakers
import balaArunachalam from "../assets/images/team/speakers/bala-arunachalam.jpg";
import balasubramanianSankaranarayanan from "../assets/images/team/speakers/balasubramanian-sankaranarayanan.jpg";
import danielRose from "../assets/images/team/speakers/daniel-rose.jpg";
import lathaSrinivasan from "../assets/images/team/speakers/latha-srinivasan.jpg";
import mohitSood from "../assets/images/team/speakers/mohit-sood.jpg";
import chetanKulkarni from "../assets/images/team/speakers/chetan-kulkarni.jpg";
import siddharthMandal from "../assets/images/team/speakers/siddharth-mandal.jpg";
import vigneshKrishnakumar from "../assets/images/team/speakers/vignesh-krishnakumar.jpg";
import vikasGade from "../assets/images/team/speakers/vikas-gade.jpg";
import suzanneMarzziotti from "../assets/images/team/speakers/suzanne-marzziotti.jpg";
import prakashKaraka from "../assets/images/team/speakers/prakash-karaka.jpg";
import sudharsanMohan from "../assets/images/team/speakers/sudharsan-mohan.jpg";
import shantanuBose from "../assets/images/team/speakers/shantanu-bose.jpg";
import raghavendranJayasubramanian from "../assets/images/team/speakers/raghavendran-jayasubramanian.jpg";
import ankit from "../assets/images/team/speakers/ankit.jpg";
import sivaKumarPadmanabhan from "../assets/images/team/speakers/siva-kumar-padmanabhan.jpg";
import stevenSbar from "../assets/images/team/speakers/steven-sbar.jpg";
import somsekharPal from "../assets/images/team/speakers/somsekhar-pal.jpg";
import raghuveeranSomwyanarayan from "../assets/images/team/speakers/raghuveeran-somwyanarayan.jpg";
import jisaBaji from "../assets/images/team/speakers/jisa-baji.jpg";
import harpreetSingh from "../assets/images/team/speakers/harpreet-singh.jpg";
import madhuKrishnan from "../assets/images/team/speakers/madhu-krishnan.jpg";

//annual conference speakers
import BalajiViswanathan from "../assets/images/speakers/annual-conference-2025/balaji-viswanathan.jpg";
import nishantZope from "../assets/images/speakers/annual-conference-2025/nishant-zope.jpg";
import johnwKeon from "../assets/images/speakers/annual-conference-2025/john-w-keon.jpg";
import subratMishra from "../assets/images/speakers/annual-conference-2025/subrat-mishra.jpg";
import rohitMarwah from "../assets/images/speakers/annual-conference-2025/rohit-marwah.jpg";
import brain from "../assets/images/speakers/annual-conference-2025/brian.jpg";
import KevinPossley from "../assets/images/speakers/annual-conference-2025/kevin-possley.jpg";
import SayantanDasgupta from "../assets/images/speakers/annual-conference-2025/sayantan-dasgupta.jpg";
import janeUrban from "../assets/images/speakers/annual-conference-2025/jane-urban.jpg";
import janeUrbanFull from "../assets/images/speakers/annual-conference-2025/jane-urban-large.jpg";
import RicardoUribe from "../assets/images/speakers/annual-conference-2025/ricardo.jpg";
import DavidAyele from "../assets/images/speakers/annual-conference-2025/dave.jpg";
import Zheng from "../assets/images/speakers/annual-conference-2025/zheng.jpg";
import SamikAdhikary from "../assets/images/speakers/annual-conference-2025/samik-adhikary.jpg";
import NikKashyap from "../assets/images/speakers/annual-conference-2025/nik-kashyap.jpg";
import MichaelKarbachinskiy from "../assets/images/speakers/annual-conference-2025/michael-karbachinskiy.jpg";
import ericFitzpatrick from "../assets/images/speakers/annual-conference-2025/eric-fitzpatrick.jpg";
import KhushtarPandit from "../assets/images/speakers/annual-conference-2025/khushtar-pandit.jpg";
import arunkumar from "../assets/images/speakers/annual-conference-2025/arunkumar.jpg";
import vishal from "../assets/images/speakers/annual-conference-2025/vishal.jpg";

// partners
import documentIt from "../assets/images/partners/document-it.png";
import zs from "../assets/images/partners/zs.png";
import chryselys from "../assets/images/partners/chryselys.png";
import defintiveHealthcare from "../assets/images/partners/definitivehc.png";
import procdna from "../assets/images/partners/procdna.png";
import purpleLab from "../assets/images/partners/purplelab.png";
import zoomRx from "../assets/images/partners/zoomrx.png";
import careset from "../assets/images/partners/careset.png";
import pharmaace from "../assets/images/partners/pharmaace.png";

// annual conference 2025
import maradyHill from "../assets/images/speakers/annual-conference-2025/marady-hill.jpg";
import ankitJain from "../assets/images/speakers/annual-conference-2025/ankit-jain.jpg";
import saiRithvik from "../assets/images/speakers/annual-conference-2025/sai-rithvik.jpg";

// events partners
import Agilisium from "../assets/images/events/anniversary-event-partners/agilisum.png";
import Kmk from "../assets/images/events/anniversary-event-partners/kmk.png";
import RosenblattLifescience from "../assets/images/events/anniversary-event-partners/rlsconsultants.png";
import tellius from "../assets/images/events/anniversary-event-partners/tellius.png";

// conference-hyderabad speaker information
import GanpatAnchaliya from "../assets/images/speakers/conference-hyderabad/ganpat-anchaliya.jpg";
import MaherIyer from "../assets/images/speakers/conference-hyderabad/maheriyer.jpg";
import annualConferenceHyderabad from "../assets/images/background/annual-conference-hyderabad.jpg";
import ShikhaAgarwal from "../assets/images/speakers/conference-hyderabad/shikha-agarwal.jpg";
import MrinalDuggal from "../assets/images/speakers/conference-hyderabad/mrinal-duggal.jpg";
import arnavSingh from "../assets/images/speakers/conference-hyderabad/arnav-singh.jpg";

const AssetPath = {
	brand: {
		pharmaSos,
		pharmaSosWhite,
	},
	annualConference: {
		maradyHill,
		ankitJain,
		saiRithvik,
		MichaelKarbachinskiy,
		ericFitzpatrick,
		KhushtarPandit,
		vishal,
		arunkumar,
	},
	conferenceHyderabad: {
		GanpatAnchaliya,
		MaherIyer,
		ShikhaAgarwal,
		MrinalDuggal,
		arnavSingh,
	},
	cta: {},

	breadcrumb: {
		aboutUsImage,
		contactUsImage,
		agendaImage,
		galleryImage,
		sponsorsImage,
		eventandRegistration,
		pastEvents,
		joinWithUsImage,
		subscribeNewsletter,
		becomeVolunteers,
		abstractSubmission,
		innovatePhrama2024,
		innovatePhrama2024Gallery,
		annualConferenceHyderabad,
	},
	sliders: {
		indiaConference,
	},
	images: {
		aboutUs,
		contactImage,
		ItcChennaiIndia,
		contact,
		contactBg,
		weloveToHearBg,
	},
	shape: {
		brushStroke,
		brushStrokeGreen,
		brushStrokeWhite,
		brushStrokeGreenFlip,
	},
	events: {
		chennaiEvents,
		summerEventMorristown,
		eventVenetianCasinoLasvegas,
		annualConference2025,
		bowlingCareset,
		hyderabadEvent,
		hyderabadEventCleanBg,
		fallEvent,
		annualConferenceTranformation,
		winterSocialBoston,
	},
	team: {
		// boardof directors
		taogu,
		KarthikChidambaram,
		ashishPatel,
		somySilvy,
		davidPurdie,
		daveBitner,
		janeChen,
		jasonCarlin,
		jinTong,
		paulomiPatel,
		sakthiAnnamalai,
		shanYeh,
		mayankMisra,

		// volunteers
		jessYoung,
		blankImage,
		ashleyPeterson,
		deviPrasadSingh,
		wingchan,
		joeFalcone,
	},
	speakers: {
		balaArunachalam,
		balasubramanianSankaranarayanan,
		danielRose,
		lathaSrinivasan,
		mohitSood,
		chetanKulkarni,
		siddharthMandal,
		vigneshKrishnakumar,
		vikasGade,
		suzanneMarzziotti,
		prakashKaraka,
		sudharsanMohan,
		shantanuBose,
		raghavendranJayasubramanian,
		ankit,
		sivaKumarPadmanabhan,
		stevenSbar,
		placeholderMenImage,
		somsekharPal,
		raghuveeranSomwyanarayan,
		jisaBaji,
		harpreetSingh,
		madhuKrishnan,
		BalajiViswanathan,
		nishantZope,
		johnwKeon,
		subratMishra,
		rohitMarwah,
		brain,
		KevinPossley,
		SayantanDasgupta,
		janeUrban,
		janeUrbanFull,
		RicardoUribe,
		DavidAyele,
		Zheng,
		SamikAdhikary,
		NikKashyap,
	},
	partners: {
		documentIt,
		zs,
		chryselys,
		defintiveHealthcare,
		procdna,
		purpleLab,
		zoomRx,
		careset,
		pharmaace,
	},
	eventPartners: {
		RosenblattLifescience,
		Agilisium,
		Kmk,
		tellius,
	},
};

export default AssetPath;
